<template>
  <div>
    <div class="columnss">
      <Categorie 
        v-for="cat in categorien"
        :cat="cat"
        :key="cat.id"
        :cart="cart"
        :search="search"
         @changed="ChangedAantal"
      ></Categorie>
    </div>
  </div>
</template>

<script>
import Categorie from './Categorie.vue'

export default {
  name: 'Categorieen',

  props: ['categorien', 'search', 'cart'],

  components: {
    Categorie
  },

  methods: {
    ChangedAantal(val) {
      this.$emit('changed', val);
    }
  },

  data() {
    return {
      
    }
  }

}
</script>

<style>
  .columnss {
    margin-top:20px;
  }
</style>
